var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60674 12.1154C4.32461 12.1154 4.07876 11.9824 3.86918 11.7163L0.20555 7.17007C0.0685166 6.99273 0 6.81539 0 6.63806C0 6.42847 0.0665015 6.25718 0.199504 6.12418C0.332507 5.99118 0.503799 5.92468 0.713379 5.92468C0.955203 5.92468 1.16478 6.03753 1.34212 6.26323L4.57046 10.3863L10.8941 0.386919C11.0554 0.128974 11.269 9.53674e-07 11.535 9.53674e-07C11.7446 9.53674e-07 11.9138 0.0644875 12.0428 0.19346C12.1718 0.322433 12.2363 0.491709 12.2363 0.701289C12.2363 0.862505 12.1758 1.03581 12.0549 1.22121L5.33221 11.7163C5.15487 11.9824 4.91305 12.1154 4.60674 12.1154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTick);
export default __webpack_public_path__ + "static/media/white-tick.699dad4e82444e0eb67d9aae4e6e2184.svg";
export { ForwardRef as ReactComponent };